import { render, staticRenderFns } from "./FormEvaluation.vue?vue&type=template&id=52c4d71e&"
import script from "./FormEvaluation.vue?vue&type=script&lang=js&"
export * from "./FormEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports